import { useQuery } from '@tanstack/react-query'
import api from '@/admin/lib/api'

interface SessionUser {
  uuid: string
  email: string
  first_name: string
  last_name: string
  is_staff: boolean
  is_superuser: boolean
}

export interface SessionData {
  is_authenticated: boolean
  user: SessionUser | null
  is_impersonating: boolean
}

export function useSession() {
  return useQuery<SessionData>({
    queryKey: ['session'],
    queryFn: () => api.get('/auth/session/').then((r) => r.data),
    retry: 1,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
